/* Supply Master power setup pilot: presentation + existing purchase integration. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.smPowerReady === '1') return;
    const form = document.getElementById(root.dataset.formId);
    if (!form) return;
    const radioList = Array.from(root.querySelectorAll('.sm-power__choice-input'));
    const batteryRadios = Array.from(root.querySelectorAll('[data-sm-power-battery]'));
    const capacityRow = root.querySelector('[data-sm-power-capacity]');
    const summary = root.querySelector('[data-sm-power-summary]');
    const total = root.querySelector('[data-sm-power-total]');
    const primaryPrice = document.querySelector('[data-sm-power-head-price]');
    const stickyPrice = document.querySelector('[data-sm-power-sticky-price]');
    const cardPrices = Object.fromEntries(['tool','complete','battery','charger'].map(k => [k,root.querySelector('[data-sm-power-card-price="'+k+'"]')]));
    const fields = Object.fromEntries(['battery-id','battery-qty','charger-id','charger-qty'].map(k => [k, form.querySelector('[data-sm-power-field="'+k+'"]')]));
    if (!fields['battery-id'] || !fields['battery-qty'] || !cardPrices.tool || !cardPrices.battery || !batteryRadios.length) return;
    root.dataset.smPowerReady = '1';
    const toolId = Number(root.dataset.toolId);
    const toolPrice = Number(root.dataset.toolPrice);
    const batteryCount = Math.max(1,Number(root.dataset.batteryQty || 1));
    const chargerId = Number(root.dataset.chargerId);
    const chargerPrice = Number(root.dataset.chargerPrice);
    const chargerAvailable = root.dataset.chargerAvailable === 'true';
    const price = cents => new Intl.NumberFormat('en-GH',{style:'currency',currency:'GHS',minimumFractionDigits:0,maximumFractionDigits:2}).format(cents / 100);
    const availableBatteries = batteryRadios.filter(r => !r.disabled);
    const hasBattery = availableBatteries.length > 0;
    for (const radio of radioList) {
      if ((radio.value === 'complete' && (!hasBattery || !chargerAvailable)) || (radio.value === 'battery' && !hasBattery) || (radio.value === 'charger' && !chargerAvailable)) {
        radio.disabled = true;
      }
    }
    if (!batteryRadios.some(r => r.checked && !r.disabled) && hasBattery) availableBatteries[0].checked = true;
    function selection() {
      const mode = radioList.find(r=>r.checked)?.value || 'tool';
      const withBattery = mode === 'battery' || mode === 'complete';
      const withCharger = mode === 'charger' || mode === 'complete';
      const battery = batteryRadios.find(r => r.checked && !r.disabled);
      const batteryId = Number(battery?.value || 0);
      const batteryPrice = Number(battery?.dataset.price || 0);
      const batteryLabel = battery?.dataset.batteryLabel || '';
      return {mode,withBattery,withCharger,batteryId,batteryPrice,batteryLabel};
    }
    function sync() {
      const s = selection();
      capacityRow.hidden = !s.withBattery;
      fields['battery-id'].value = String(s.batteryId);
      fields['battery-id'].disabled = !s.withBattery;
      fields['battery-qty'].disabled = !s.withBattery;
      const qtyInput = form.querySelector('[name="quantity"]');
      const unitCount = Math.max(1,Math.floor(Number(qtyInput?.value || 1)));
      fields['battery-qty'].value = String(batteryCount*unitCount);
      if (fields['charger-id']) {
        fields['charger-id'].value = String(chargerId);
        fields['charger-id'].disabled = !s.withCharger;
      }
      if (fields['charger-qty']) {
        fields['charger-qty'].disabled = !s.withCharger;
        fields['charger-qty'].value = String(unitCount);
      }
      const amounts = {
        tool:toolPrice,
        battery:toolPrice+s.batteryPrice*batteryCount,
        charger:toolPrice+chargerPrice,
        complete:toolPrice+s.batteryPrice*batteryCount+chargerPrice
      };
      Object.entries(cardPrices).forEach(([mode,el]) => {if(el) el.textContent = price(amounts[mode]);});
      root.dataset.smPowerUnitCents = String(amounts[s.mode]);
      document.dispatchEvent(new CustomEvent('sm:power:change',{detail:{unitPriceCents:amounts[s.mode],mode:s.mode}}));
      const display = price(amounts[s.mode]);
      total.textContent = display;
      if (primaryPrice) primaryPrice.textContent = display;
      if (stickyPrice) stickyPrice.textContent = display;
      const items = ['Tool'];
      if (s.withBattery) items.push((batteryCount>1?batteryCount+' × ':'')+s.batteryLabel + ' battery');
      if (s.withCharger) items.push('Charger');
      summary.textContent = items.join(' · ');
    }
    for (const r of radioList) r.addEventListener('change',sync);
    for (const r of batteryRadios) r.addEventListener('change',sync);
    form.querySelector('[name="quantity"]')?.addEventListener('change',sync);
    sync();
    form.addEventListener('submit', async function(event) {
      // Accelerated-checkout buttons read shopify-additional-items fields directly.
      // Intercept only standard Add to cart; prevent Enterprise's single-item handler.
      if (event.submitter && event.submitter.name !== 'add') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const btn = form.querySelector('button[name="add"]');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      const s = selection();
      if ((s.withBattery && !s.batteryId) || (s.withCharger && !chargerAvailable)) return;
      const qtyInput = form.querySelector('[name="quantity"]');
      const toolQty = Math.max(1,Math.floor(Number(qtyInput?.value || 1)));
      const items = [{id:toolId,quantity:toolQty}];
      if(s.withBattery) items.push({id:s.batteryId,quantity:batteryCount*toolQty});
      if(s.withCharger) items.push({id:chargerId,quantity:toolQty});
      const err = form.querySelector('.js-form-error');
      if(err) {err.hidden=true;err.textContent='';}
      btn.setAttribute('aria-disabled','true');
      btn.classList.add('is-loading');
      try {
        const drawer = document.querySelector('cart-drawer');
        const sections = ['cart-icon-bubble'];
        if(drawer) sections.push(drawer.closest('.shopify-section').id.replace('shopify-section-',''));
        const resp = await fetch(window.theme?.routes?.cartAdd || '/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({items,sections:sections.join(','),sections_url:location.pathname})
        });
        const data = await resp.json();
        if(!resp.ok || data.status) throw new Error(data.description || data.message || 'Unable to add selected items.');
        if(window.theme?.settings?.afterAtc === 'page') {location.assign(window.theme.routes.cart);return;}
        const bubble=document.getElementById('cart-icon-bubble');
        if(bubble && data.sections?.['cart-icon-bubble']) bubble.innerHTML=data.sections['cart-icon-bubble'];
        if(drawer) {
          if(data.sections && data.sections[sections[1]]) {
            await drawer.renderContents(data,window.theme?.settings?.afterAtc === 'drawer');
          } else {
            await drawer.refresh(true);
            if(window.theme?.settings?.afterAtc === 'drawer') drawer.open();
          }
        }
        form.dispatchEvent(new CustomEvent('on:cart:add',{bubbles:true,detail:{variantId:toolId}}));
      } catch(e) {
        if(err){err.textContent=e.message || 'Please retry.';err.hidden=false;}
        form.dispatchEvent(new CustomEvent('on:cart:error',{bubbles:true,detail:{error:e.message}}));
      } finally {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-loading');
      }
    }, true);
  }
  function boot(){document.querySelectorAll('[data-sm-power]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();
